export default "__VITE_ASSET__Ci86pj1B__"